import CompleteSendEmailForgotPassword from '../../cast/castForgotPassword/completeSendEmailForgotPassword';

export default function CustomerCompleteSendEmailForgotPassword() {
  return <CompleteSendEmailForgotPassword changePassword={false} />;
}
